console.log(""); 
// document.addEventListener('DOMContentLoaded', removeFeeIfLast); test
//
// function removeFeeIfLast() {
//   let products = [];
//   let item_class = ".cart__sort_item";
//   let countlinesToDelete = 2;
//   let isContinue = false;
//
//   jQuery(jQuery("h3.h1")[0]).hide();
//
//   console.warn("!!!!!!!!!! cart-control-script !!!!!!!!!!");
//
//   let loopItems = function() {
//
//     let items = jQuery(item_class);
//
//     jQuery.each(items, (key, value) => {
//       let product_id = jQuery(value).data('product_id');
//
//       if(!products.includes(product_id)) {
//           if(typeof(products[product_id]) != "undefined") {
//             products[product_id] ++;
//           } else {
//             products[product_id] = 1;
//           }
//       }
//     });
//
//     return products;
//   }
//
//   let updateCart = function(updatesData) {
//     let result = jQuery.post(
//       window.Shopify.routes.root + 'cart/update.js',
//       {
//         updates: updatesData
//       }
//     ).done( qwResult => {
//       setTimeout(() => {
//         console.warn("Set timout worked");
//         window.location.reload();
//       }, "2 second");
//     }).fail(() => {
//       alert("error");
//     }).always(() => {
//       console.log("finished");
//     });
//   }
//
//   jQuery(".cart__remove-btn").click( function(event) {
//     event.preventDefault();
//
//     let currentProductId = jQuery(this).data('product_id');
//     products = loopItems();
//
//     let countLinesForCurrentProduct = products[currentProductId];
//     let updateVariants = {};
//
//     if(countLinesForCurrentProduct == countlinesToDelete) {
//       /*localStorage.removeItem("discountCode");*/
//       let currentElements = jQuery(item_class + '-' + currentProductId);
//
//       jQuery.each(currentElements, (key, value) => {
//         updateVariants[jQuery(value).data('variant_id')] = 0;
//       });
//
//       updateCart(updateVariants);
//     } else {
//       let currentVariantId = jQuery(this).data('variant_id');
//       updateVariants[currentVariantId] = 0;
//       updateCart(updateVariants);
//     }
//   });
// }